<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{gear.id ? ('bikeshop.modal.component.edit_component' | translate) : ('bikeshop.modal.component.add_component' | translate)}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')" *ngIf="closeModal">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="ComponentForm" (ngSubmit)="saveComponent()">
        <div class="row">
            <div class="col-md-2 label">*{{ 'bikeshop.modal.component.gear_type' | translate }}:</div>
            <div class="col-md-10 value">
                <p-dropdown [options]="gearTypeOptions" formControlName="TypeID"></p-dropdown>
            </div>
        </div>

        <div class="row margin-top-8">
            <div class="col-md-2 label">*{{ 'bikeshop.modal.component.manufacturer' | translate }}:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input maxlength="50" type="text" pInputText formControlName="Manufacturer"
                           placeholder="{{ 'bikeshop.modal.component.manufacturer' | translate }}"/>
                </div>
            </div>
            <div class="col-md-2 label">*{{ 'bikeshop.modal.component.model' | translate }}:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input maxlength="100" type="text" pInputText formControlName="Model"
                           placeholder="{{ 'bikeshop.modal.component.model' | translate }}"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">*{{ 'bikeshop.modal.component.description' | translate }}:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input maxlength="100" type="text" pInputText formControlName="Description"
                           placeholder="{{ 'bikeshop.modal.component.description' | translate }}"/>
                </div>
            </div>
            <!--<div class="col-md-2 label">{{ 'bikeshop.modal.component.sku' | translate }}:</div>
            <div class="col-md-4">
              <div class="p-inputgroup">
                <input type="text" readonly pInputText formControlName="SKU" placeholder="{{ 'bikeshop.modal.component.sku' | translate }}" />
              </div>
            </div>-->
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">*{{ 'bikeshop.modal.component.date_added' | translate }}:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-calendar"></i></span>
                    <p-calendar formControlName="DateAdded" dateFormat="{{countryData.DatePickerFormat}}"
                                [monthNavigator]="true" [yearNavigator]="true" (onShow)="moveAddedCalendar()"
                                yearRange="1980:2030"></p-calendar>
                </div>
            </div>
            <div class="col-md-2 label" *ngIf="gear.id > 0">*{{ 'bikeshop.modal.component.last_serviced' | translate }}
                :
            </div>
            <div class="col-md-4" *ngIf="gear.id > 0">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-calendar"></i></span>
                    <p-calendar formControlName="LastService" dateFormat="{{countryData.DatePickerFormat}}" panelStyleClass="calendarright"
                                [minDate]="ComponentForm.value.DateAdded" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1980:2090"  (onShow)="moveLastServiceCalendar()"></p-calendar>
                </div>
            </div>
        </div>

        <div class="row margin-top-8">
            <div class="col-md-12">{{ 'bikeshop.modal.component.set_service_interval_unit' | translate }}:</div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">{{ 'bikeshop.modal.component.select_unit' | translate }}:</div>
            <div class="col-md-4">
                <p-dropdown [options]="units" [(ngModel)]="selectedUnit" (ngModelChange)="setIntervalControls()"
                            [ngModelOptions]="{standalone: true}"></p-dropdown>
            </div>

            <div class="col-md-2 label" *ngIf="selectedUnit==='km'">
                {{ 'bikeshop.modal.component.service_interval' | translate }} ({{distanceMetric}}):
            </div>
            <div class="col-md-4" *ngIf="selectedUnit==='km'">
                <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="KmServiceInterval"/>
                </div>
            </div>

            <div class="col-md-2 label" *ngIf="selectedUnit==='hours'">
                {{ 'bikeshop.modal.component.service_interval' | translate }} ({{ 'general.hrs' | translate }}):
            </div>
            <div class="col-md-4" *ngIf="selectedUnit==='hours'">
                <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="MinutesServiceInterval"/>
                </div>
            </div>

            <div class="col-md-2 label" *ngIf="selectedUnit==='months'">
                {{ 'bikeshop.modal.component.service_interval' | translate }} ({{ 'general.months' | translate }}):
            </div>
            <div class="col-md-4" *ngIf="selectedUnit==='months'">
                <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="MonthsServiceInterval"/>
                </div>
            </div>

        </div>

        <div class="component-indicators"
             *ngIf="gear.id > 0 && gear.serviceTimeframe === 'km' && selectedUnit === 'km'">
            <div class="row margin-top-8">
                <div class="col-md-3 label">{{distanceMetric}} {{ 'bikeshop.modal.component.when_added' | translate }}
                    :
                </div>
                <div class="col-md-3 value">
                    {{gear.openingKm}} {{distanceMetric}}
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-3 label">{{distanceMetric}} {{ 'bikeshop.modal.component.since_last_service' | translate }}
                    :
                </div>
                <div class="col-md-3 value">
                    {{gear.kmSinceLastService}} {{distanceMetric}}
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-3 label">{{distanceMetric}} {{ 'bikeshop.modal.component.till_next_service' | translate }}
                    :
                </div>
                <div class="col-md-3 value">
                    {{gear.kmToNextService}} {{distanceMetric}}
                </div>
                <div class="col-md-2 label">{{ 'bikeshop.modal.component.service_indicator' | translate }}:</div>
                <div class="col-md-4" style="margin-top:3px;">
                    <p-progressBar [value]="100 - gear.serviceScore">
                    </p-progressBar>
                </div>
            </div>
        </div>
        <div class="component-indicators"
             *ngIf="gear.id > 0 && gear.serviceTimeframe === 'hours' && selectedUnit === 'hours'">
            <div class="row margin-top-8">
                <div class="col-md-3 label">{{ 'bikeshop.modal.component.hours_when_added' | translate }}:</div>
                <div class="col-md-3 value">
                    {{gear.openingHours / 60 | number : '.1-1'}} {{ 'general.hrs' | translate }}
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-3 label">{{ 'bikeshop.modal.component.total_hours' | translate }}:</div>
                <div class="col-md-3 value">
                    {{gear.totalHours / 60 | number : '.1-1'}} {{ 'general.hrs' | translate }}
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-3 label">{{ 'bikeshop.modal.component.hours_till_next_service' | translate }}:</div>
                <div class="col-md-3 value">
                    {{gear.hoursToNextService / 60 | number : '.1-1'}} {{ 'general.hrs' | translate }}
                </div>
                <div class="col-md-2 label">{{ 'bikeshop.modal.component.service_indicator' | translate }}:</div>
                <div class="col-md-4" style="margin-top:3px;">
                    <p-progressBar [value]="100 - gear.serviceScore">
                    </p-progressBar>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-md-3">
            <button pButton class="full-width alternate"
                    label="{{ 'bikeshop.modal.component.button.retire_component' | translate }}" *ngIf="gear.id>0"
                    (click)="retireComponent()"></button>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
            <button pButton class="full-width"
                    label="{{gear.id > 0 ? ('bikeshop.modal.component.button.save_component' | translate ) : ('bikeshop.modal.component.button.add_component' | translate )}}"
                    (click)="saveComponent()" [disabled]="!ComponentForm.valid || saving || !checkIfValid()"></button>
        </div>
    </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
